import React from 'react';
import { ListFilter } from 'lucide-react';
import CompactSelectPicker from '../ui/CompactSelectPicker';
import { LIST_SORT_OPTIONS, SORT_MANUAL } from '../../extensions/bundled/task-manager/listViewSort';
import useListViewPrefs from './useListViewPrefs';
import './ListSortControl.css';

/** "⇅ Sort: Manual ▾" at the right end of the filter row in List view (Boards
 *  Redesign card 6.3): one bordered 28 px button like the ListView artboard,
 *  the app's CompactSelectPicker with the sort icon drawn inside its trigger.
 *  Per device and per board (useListViewPrefs); nothing is written into the
 *  board. Any order but Manual turns row dragging off. No tooltip (owner,
 *  13.10.2026: it covered the open menu). */
export default function ListSortControl({ boardId }) {
  const { sort, setSort } = useListViewPrefs(boardId);
  const sorted = sort !== SORT_MANUAL;
  return (
    <div className={`task-board-list-sort${sorted ? ' task-board-list-sort--on' : ''}`}>
      <span className="task-board-list-sort-icon" aria-hidden="true">
        <ListFilter size={12} strokeWidth={2.2} />
      </span>
      <CompactSelectPicker
        value={sort}
        onChange={setSort}
        options={LIST_SORT_OPTIONS}
        className="task-board-list-sort-picker"
        menuMinWidth={190}
        aria-label="Sort tasks"
      />
    </div>
  );
}
